import { isOpenFinRuntime } from '../../../containers/OpenFin/helpers'
import { useAppSelector } from '../../../store/types'
import { foregroundAggressorWindowAtIndex } from '../../../store/windows/actions'
import {
  getActiveAggressorWindow,
  getAggressorWindows
} from '../../../store/windows/selectors'
import Wrapper from '../../Wrapper/Wrapper'
import AggressorModal from '../AggressorModal/AggressorModal'
import { useActiveWindow } from '../helpers'

const AggressorModalStack = () => {
  const isOpenFin = isOpenFinRuntime()
  const aggressorWindows = useAppSelector(getAggressorWindows)
  const activeModalIndex = useAppSelector(getActiveAggressorWindow)
  const { handleMinimize } = useActiveWindow(
    aggressorWindows.length,
    activeModalIndex,
    foregroundAggressorWindowAtIndex
  )

  if (isOpenFin || aggressorWindows.length === 0) return null
  return (
    <Wrapper>
      {aggressorWindows.map((windowInfo, i) => (
        <AggressorModal
          key={windowInfo.initialOrderId + windowInfo.transactionId}
          windowInfo={windowInfo}
          isActiveWindow={activeModalIndex === i}
          handleMinimize={handleMinimize}
          index={i}
        />
      ))}
    </Wrapper>
  )
}
export default AggressorModalStack
